import styled from 'styled-components';

const MainContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.9);
  padding: ${({ theme }) => theme.spacings.base}px;
  border-radius: 10px;
`;

export default MainContainer;
